const getAlternativeName = (letter, alternatives = []) => {
  if (!letter) return ''
  const match = alternatives.find(
    (alternative) =>
      (alternative?.letter || '').toUpperCase() === letter.toUpperCase(),
  )
  return match?.title || match?.name || match?.description || ''
}

export default getAlternativeName
